import React, { useEffect, useMemo, useState } from 'react';
import Page from '../../components/PageWrapper';
import { Outlet } from 'react-router-dom';

function FinancingOutlet() {

    return (
        <Page title="Financing">
            <Outlet />
        </Page>
    );
}

export default FinancingOutlet;
